<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-terminal`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 5a2 2 0 012 2v27a2 2 0 01-2 2H26v2.999L33 39a1 1 0 011 1v2a1 1 0 01-1 1l-7-.001V43h-4v-.001L15 43a1 1 0 01-1-1v-2a1 1 0 011-1l7-.001V36H5a2 2 0 01-2-2V7a2 2 0 012-2h38zm-2 4H7v23h34V9zm-10.732 3.707l3.864 1.035-4.141 15.455-3.864-1.035 4.141-15.455zM21.485 12l2.829 2.828-5.683 5.682 5.268 5.268-2.828 2.829-7.778-7.779.025-.025-.318-.318L21.485 12z"/></svg>
</template>
<script>

export default {
  name: 'IconTerminal',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
